import { Link } from 'react-router-dom';
import { categories } from '@/mocks/doujin';
import NewsletterForm from '@/components/NewsletterForm';

export default function Footer() {
  return (
    <footer className="w-full bg-background-800 text-background-100 mt-16">
      <div className="px-4 md:px-6 max-w-7xl mx-auto py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-2.5 mb-4">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
              <i className="ri-book-open-line"></i>
            </span>
            <span className="font-heading text-xl font-bold text-background-50">今日同人库</span>
          </Link>
          <p className="text-sm leading-relaxed text-background-300">
            一个每日整理同人作品更新动态、最新汉化与新作连载的资讯站点。点开今日同人库，追更不再错过。
          </p>
          <div className="flex items-center gap-3 mt-5">
            {['ri-weibo-line', 'ri-bilibili-line', 'ri-tumblr-line', 'ri-qq-line'].map((ic) => (
              <a
                key={ic}
                href="#subscribe"
                aria-label="社交平台"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors"
              >
                <i className={ic}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50 mb-4">网站栏目</h4>
          <ul className="space-y-2.5 text-sm text-background-300">
            <li><Link to="/" className="hover:text-accent-300 transition-colors">今日更新速递</Link></li>
            <li><Link to="/updates" className="hover:text-accent-300 transition-colors">全部更新流</Link></li>
            <li><Link to="/faq" className="hover:text-accent-300 transition-colors">追更指南</Link></li>
            <li><Link to="/about" className="hover:text-accent-300 transition-colors">关于我们</Link></li>
            <li><Link to="/contact" className="hover:text-accent-300 transition-colors">联系我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50 mb-4">主题分类</h4>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm text-background-300">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/category/${c.slug}`} className="hover:text-accent-300 transition-colors whitespace-nowrap">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div id="subscribe">
          <h4 className="font-heading text-base font-semibold text-background-50 mb-4">订阅更新速递</h4>
          <p className="text-sm text-background-300 mb-4 leading-relaxed">
            留下邮箱，第一时间收到今日同人库今日更新与最新汉化提醒。
          </p>
          <NewsletterForm />
        </div>
      </div>

      <div className="border-t border-background-700">
        <div className="px-4 md:px-6 max-w-7xl mx-auto py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 今日同人库 · 每日整理同人更新动态，内容仅供爱好者交流与追更参考</p>
          <div className="flex items-center gap-5">
            <Link to="/faq" className="hover:text-background-200 transition-colors">使用说明</Link>
            <Link to="/about" className="hover:text-background-200 transition-colors">内容原则</Link>
            <Link to="/contact" className="hover:text-background-200 transition-colors">合作联系</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}